module.exports = __webpack_public_path__ + "static/media/BNB-logo.162aaf57.png";